angular.module('sharecrf.internal-value').constant('MISSING_VALUE', '#MISSING#');
